import {
	IonItem,
	IonLabel,
	IonNote,
	IonList,
	IonCheckbox,
	IonTextarea,
} from "@ionic/react";
import React from "react";
import Spacer from "../../../components/spacer";

interface props {
	field: any;
	fieldName: any;
	onChange: any;
}

const FormBehaviours: React.FC<props> = ({ field, fieldName, onChange }) => {
	return (
		<IonList>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="bed"
					data-id={fieldName}
					name="bed"
					checked={field.bed}
				/>
				<IonLabel>Left their bed</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="parent"
					data-id={fieldName}
					name="parent"
					checked={field.parent}
				/>
				<IonLabel>Called out for a parent</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="food"
					data-id={fieldName}
					name="food"
					checked={field.food}
				/>
				<IonLabel>Requested food or drink</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="activities"
					data-id={fieldName}
					name="activities"
					checked={field.activities}
				/>
				<IonLabel>Requested activities</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="physical"
					data-id={fieldName}
					name="physical"
					checked={field.physical}
				/>
				<IonLabel>Requested physical attention (e.g., a cuddle)</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="fear"
					data-id={fieldName}
					name="fear"
					checked={field.fear}
				/>
				<IonLabel>Reported fear</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="toilet"
					data-id={fieldName}
					name="toilet"
					checked={field.toilet}
				/>
				<IonLabel>Visited the toilet</IonLabel>
			</IonItem>

			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="stereotypic"
					data-id={fieldName}
					name="stereotypic"
					checked={field.stereotypic}
				/>
				<IonLabel>
					Stereotypic/repetitive behaviour (e.g. bouncing, rocking,
					vocalisations)
				</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="electronics"
					data-id={fieldName}
					name="electronics"
					checked={field.electronics}
				/>
				<IonLabel>
					Used electronics/devices (e.g., iPad, T.V., or laptop)
				</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="toys"
					data-id={fieldName}
					name="toys"
					checked={field.toys}
				/>
				<IonLabel>Played with toys</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="book"
					data-id={fieldName}
					name="book"
					checked={field.book}
				/>
				<IonLabel>Read a book</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="tantrum"
					data-id={fieldName}
					name="tantrum"
					checked={field.tantrum}
				/>
				<IonLabel>Tantrum behaviour (e.g. crying)</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="hid"
					data-id={fieldName}
					name="hid"
					checked={field.hid}
				/>
				<IonLabel>Hid</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="sibling"
					data-id={fieldName}
					name="sibling"
					checked={field.sibling}
				/>
				<IonLabel>Interacted with a sibling</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="parentBed"
					data-id={fieldName}
					name="parentBed"
					checked={field.parentBed}
				/>
				<IonLabel>Moved into parental bed/attempted to</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="other"
					data-id={fieldName}
					name="other"
					checked={field.other}
				/>
				<IonLabel>Other</IonLabel>
			</IonItem>
			{field.other && (
				<IonItem>
					<IonLabel position="stacked">
						Please describe other behaviours
					</IonLabel>
					<IonTextarea
						name="otherDescribe"
						id="otherDescribe"
						data-id={fieldName}
						value={field.otherDescribe}
						onIonChange={onChange}
					/>
				</IonItem>
			)}
		</IonList>
	);
};

export default FormBehaviours;
